import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from "@shared/components";
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Allergy} from '@core/classes/tables/allergy';
import {HttpHeaders} from '@angular/common/http';
import {SocialHistory} from '@core/classes/tables/social-history';
import {NavigationEnd, Router} from '@angular/router';
import {
  SurgicalProcedureStatusActionComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/surgical-procedure-status-action/surgical-procedure-status-action.component';
import {
  AddSurgicalProcedureComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/add-surgical-procedure/add-surgical-procedure.component';
import {
  SurgicalProcedureUnknownValuesComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/surgical-procedure-unknown-values/surgical-procedure-unknown-values.component';
import {
  AddSocialHistoryComponent
} from '@modules/cy/patient/ps/components/social-history/actions/add-social-history/add-social-history.component';
import {
  SocialHistoryStatusActionComponent
} from '@modules/cy/patient/ps/components/social-history/actions/social-history-status-action/social-history-status-action.component';
import {SurgicalProcedure} from '@core/classes/tables/surgical-procedure';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-social-history',
    imports: [
        TableComponent
    ],
  templateUrl: './social-history.component.html',
  styleUrl: './social-history.component.scss',
})
export class SocialHistoryComponent implements OnInit {
  @ViewChild('socialHistory') public allergiesEl!: TableComponent<SocialHistory>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<SocialHistory>>(
    new TableOptions<SocialHistory>({
      id: 'socialHistory',
      type: 'SocialHistory',
      interface: SocialHistory,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-social-history',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<SocialHistory>({
            id: 'socialHistory',
            type: 'SocialHistory',
            interface: SocialHistory,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? SocialHistoryStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddSocialHistoryComponent : undefined,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as SocialHistory;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }
}
